<template>
    <div class="home_wrap">
        <div class="breadBox">
            <div class="breadItem"><span>首页</span></div>
            <!-- <el-button type="danger" @click="toPowerCode">开发管理</el-button> -->
            <!-- <el-button type="danger" @click="toMenuCeshi">菜单管理</el-button> -->
        </div>
        <div class="content">
            <!-- 第一行 -->
            <div class="row twoBlock">
                <div class="panelBox">
                    <div class="panelTitle">待处理事务</div>
                    <div class="panelContent">
                        <div class="fangBlock" @click="toCustomerLists('p')">
                            <div class="num">
                                <span v-if="!infoObj.pendingUserAuthSum&&infoObj.pendingUserAuthSum!=0">*</span>
                                {{infoObj.pendingUserAuthSum}}
                            </div>
                            <div class="text">待企业认证</div>
                        </div>
                        <div class="fangBlock" @click="toOrderLists">
                            <div class="num">
                                <span v-if="!infoObj.order">*</span>
                            </div>
                            <div class="text">待订单审核</div>
                        </div>
                    </div>
                </div>
                <div class="panelBox">
                    <div class="panelTitle">累计数据</div>
                    <div class="panelContent">
                        <div class="fangBlock" @click="toCustomerLists">
                            <div class="num">
                            {{infoObj.totalUserCount}}
                            <span v-if="!infoObj.totalUserCount&&infoObj.totalUserCount!=0">*</span>
                            </div>
                            <div class="text">累计客户人数</div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- 第2行 -->
            <div class="row">
                <div class="panelBox">
                    <div class="panelTitle">今日概况</div>
                    <div class="panelContent">
                        <div class="line">
                            <div class="changBlock">
                                <span class="text">模块订阅客户数量</span>
                                <span class="num">
                                {{infoObj.dingyue}}
                                <span v-if="!infoObj.dingyue&&infoObj.dingyue!=0">*</span>
                                </span>
                            </div>
                        </div>
                        <div class="line">
                            <div class="changBlock" @click="toCustomerLists">
                                <span class="text">生产商申请认证数量</span>
                                <span class="num">{{infoObj.todayShengChanSum}}</span>
                            </div>
                            <div class="changBlock" @click="toCustomerLists">
                                <span class="text">品牌商申请认证数量</span>
                                <span class="num">{{infoObj.todayPinPaiSum}}</span>
                            </div>
                        </div>
                        <div class="line">
                            <div class="changBlock" @click="toOrderLists">
                                <span class="text">包工包料发单数量</span>
                                <span class="num">{{infoObj.todayOemOrderSum}}</span>
                            </div>
                            <div class="changBlock" @click="toOrderLists">
                                <span class="text">来料加工发单数量</span>
                                <span class="num">{{infoObj.todayCmtOrderSum}}</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>


        </div>
        
    </div>

</template>

<script>
    import {        json,        wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,        api    } from '@/common/request.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                infoObj: {
                    totalUserCount: "",
                }
            }
        },
        computed: {
            adminId() {
                let oUserInfo=sessionStorage.getItem('userInfo')?JSON.parse(sessionStorage.getItem('userInfo')) :{}
                console.log(oUserInfo.adminId,'computed里的adminId')
                return oUserInfo.adminId
            },
        },
        methods: {
            toPowerCode(){
              this.$router.push("/functionManager")  
            },
            toMenuCeshi(){
                this.$router.push("/leftMenuManager")  

            },
            getUserPowerData(){
                  let _this=this
                  let arg={
                      adminId:_this.adminId
                  }
                  if(!_this.adminId){
                      return false
                  }
                  ajaxPost('/admin/user/showRoleQx',arg).then(function(res){
                      if(res.errorCode==200){
                          let haveAddPowerPageArr=[]
                          let haveModifyPowerPageArr=[]
                          let haveQueryPowerPageArr=[]
                          let haveDeletePowerPageArr=[]
                          res.data.forEach(function(item,index){
                              let perimissionObj=JSON.parse(item)[0]
                              console.log(item)
                              console.log(perimissionObj)
                              if(perimissionObj.permissionType=='add'){
                                  haveAddPowerPageArr=perimissionObj.qxMenuIds.split(",")
                              }
                              if(perimissionObj.permissionType=='modify'){
                                  haveModifyPowerPageArr=perimissionObj.qxMenuIds.split(",")
                              }
                              if(perimissionObj.permissionType=='query'){
                                  haveQueryPowerPageArr=perimissionObj.qxMenuIds.split(",")
                              }
                              if(perimissionObj.permissionType=='delete'){
                                  haveDeletePowerPageArr=perimissionObj.qxMenuIds.split(",")
                              }
                              
                          })
                          console.log(haveAddPowerPageArr,haveModifyPowerPageArr,haveQueryPowerPageArr,haveDeletePowerPageArr)
                          utils.setItem("haveAddPowerPageJson", JSON.stringify(haveAddPowerPageArr))
                          utils.setItem("haveModifyPowerPageJson", JSON.stringify(haveModifyPowerPageArr))
                          utils.setItem("haveQueryPowerPageJson", JSON.stringify(haveQueryPowerPageArr))
                          utils.setItem("haveDeletePowerPageJson", JSON.stringify(haveDeletePowerPageArr))
                      }else{
                      }
                  },function(res){
                  })  
            },
             toUser(){
              this.$router.push("/userManager")  
            },
            toCustomerLists(arg){
              if(arg=='p'){
                  this.$router.push({ path: '/customerList', query: { from: 'home' }});
              }else{
                  this.$router.push("/customerList")  

              }
            },
            toOrderLists(){
                this.$router.push("/orderList")
            },
            ceshi() {
                let _this = this
            },
            getData() {
                 let _this = this
                ajaxPost('/admin/yijiajiaIndex/indexList', "").then(function(res) {
                    _this.infoObj.totalUserCount=res.data.totalUserCount
                    _this.infoObj.todayShengChanSum=res.data.todayShengChanSum
                    _this.infoObj.todayPinPaiSum=res.data.todayPinPaiSum
                    _this.infoObj.todayOemOrderSum=res.data.todayOemOrderSum
                    _this.infoObj.todayCmtOrderSum=res.data.todayCmtOrderSum
                    _this.infoObj.pendingUserAuthSum=res.data.pendingUserAuthSum
                }, function(res) {})

            },
        },
        mounted() {
            let _this = this
            this.getData()
            this.getUserPowerData()
        }
    }
</script>

<style scoped lang="scss">
    // *{outline:1px solid blue;}
    .home_wrap {
        .content {
            padding: 15px;

            .row {
                margin-bottom: 20px;

                .panelBox {
                    display: inline-block;
                    margin-right: 50px;

                    .panelTitle {
                        border-left: 3px solid $lighterColor;
                        padding-left: 20px;
                        font-weight: bold;
                        line-height: 18px;
                        margin: 29px 0 18px;
                        font-size: 20px;
                    }

                    .panelContent {
                        .changBlock:hover,.fangBlock:hover{box-shadow: 0 0 20px 0px #badaf1;cursor: pointer;border-radius: 4px;}
                        .fangBlock {
                            display: inline-block;
                            margin-right: 10px;
                            background: #fff;
                            text-align: center;
                            width: 250px;

                            .num {
                                height: 70px;
                                padding: 40px 0 20px;
                                color: $lighterColor;
                                font-size: 56px;
                                font-weight: bold;
                            }

                            .text {
                                padding-bottom: 45px;
                                color: #999;
                                font-size: 16px;
                            }
                        }

                        .line {
                            margin-bottom: 10px;

                            .changBlock {
                                display: inline-block;
                                background: #fff;
                                margin-right: 10px;
                                font-size: 14px;
                                height: 60px;
                                line-height: 60px;
                                padding: 0 20px;

                                .text {
                                    color: #919293;
                                    display: inline-block;
                                    width: 150px;
                                }

                                .num {
                                    color: #000;
                                    width: 120px;
                                    display: inline-block;
                                    font-weight: bold;
                                }
                            }
                        }


                    }
                }
            }

        }


    }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue